import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorOpacityOnLightHover, Spacing8 } from 'autogen/design-tokens/tokens';
import type { ProductListResultViewModel } from 'autogen/swagger/all';
import { ClearAll } from 'autogen/translation-keys/trans-website-filter';
import { Typography } from 'components/generic/typography';
import useFilters from '../../../shared/hooks/useFilters';

/* #region styles */
const Button = styled.button`
    display: flex;
    height: 25px;
    align-items: center;
    padding: 0 ${Spacing8};
    border: none;
    background-color: transparent;
    border-radius: 2px;
    white-space: nowrap;

    &:hover {
        background-color: ${ColorOpacityOnLightHover};
    }
`;
/* #endregion */

const ClearAllActiveFiltersButton = ({
    model: activeFilterValues
}: {
    model: ProductListResultViewModel['activeFilterValues'];
}) => {
    const { removeFiltersByQueryStrings } = useFilters();

    const queryStringsToRemove = activeFilterValues.map((activeFilter) => activeFilter.queryStringName);
    const { t } = useTranslation();
    return (
        <Button onClick={() => removeFiltersByQueryStrings(queryStringsToRemove)}>
            <Typography.Body as="span" size="S" strong>
                {t(ClearAll)}
            </Typography.Body>
        </Button>
    );
};

export default memo(ClearAllActiveFiltersButton);
